var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMajorCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 42.0352H63.3333",
    stroke: "#213B98",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 34.2654V58.0987C63.2333 67.5987 60.6332 69.9987 50.7332 69.9987H19.2668C9.2001 69.9987 6.66667 67.4987 6.66667 57.5654V34.2654C6.66667 25.2654 8.76667 22.3654 16.6667 21.8987C17.4667 21.8654 18.3334 21.832 19.2668 21.832H50.7332C60.7999 21.832 63.3333 24.332 63.3333 34.2654Z",
    stroke: "#213B98",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3333 22.4333V45.7333C73.3333 54.7333 71.2333 57.6333 63.3333 58.1V34.2667C63.3333 24.3333 60.7999 21.8333 50.7332 21.8333H19.2668C18.3334 21.8333 17.4667 21.8667 16.6667 21.9C16.7667 12.4 19.3668 10 29.2668 10H60.7332C70.7999 10 73.3333 12.5 73.3333 22.4333Z",
    fill: "#051758",
    stroke: "#213B98",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 59.3672H23.2332",
    stroke: "#213B98",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3666 59.3672H41.8333",
    stroke: "#213B98",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajorCard);
export default __webpack_public_path__ + "static/media/major_card.0d914e572254099c8f1a2d06823b2bf7.svg";
export { ForwardRef as ReactComponent };